import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button } from 'antd';
import text from './ClientList.page.translation';

class AddClientForm extends Component {
  submitForm = event => {
    event.preventDefault();

    const {
      form: { validateFields },
    } = this.props;

    validateFields(this._onValidateFieldsSuccess);
  };

  _onValidateFieldsSuccess = (err, formValues) => {
    const { onSubmitForm } = this.props;

    if (!err) {
      onSubmitForm(formValues);
    }
  };

  renderFooter = () => {
    const {
      intl: { formatMessage },
      formCancel,
      createNewClientLoading,
    } = this.props;

    const mandatoryLabel = `(*) ${formatMessage(text.formAdd.labelMandatory)}`;

    return (
      <div className="footer-container">
        <Button
          type="primary"
          htmlType="submit"
          className="btn"
          loading={createNewClientLoading}
        >
          {formatMessage(text.formAdd.buttonCreate)}
        </Button>
        <Button type="default" className="cancel-btn" onClick={formCancel}>
          {formatMessage(text.formAdd.buttonCancel)}
        </Button>
        <div className="mandatory-label">{mandatoryLabel}</div>
      </div>
    );
  };

  render() {
    const {
      form: { getFieldDecorator },
      intl: { formatMessage },
    } = this.props;

    return (
      <Form onSubmit={this.submitForm} className="delivery-add-client-form">
        <Form.Item
          label={formatMessage(text.formAdd.labelClientName)}
          required
          colon={false}
        >
          {getFieldDecorator('name', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: formatMessage(text.formAdd.requiredClientName),
              },
            ],
          })(
            <Input
              placeholder={formatMessage(text.formAdd.placeholderClientName)}
              size="large"
            />,
          )}
        </Form.Item>
        <Form.Item
          label={formatMessage(text.formAdd.labelPicEmail)}
          required
          colon={false}
        >
          {getFieldDecorator('email', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: formatMessage(text.formAdd.requiredPicEmail),
              },
              {
                type: 'email',
                message: formatMessage(text.formAdd.invalidPicEmail),
              },
            ],
          })(
            <Input
              placeholder={formatMessage(text.formAdd.placeholderPicEmail)}
              size="large"
            />,
          )}
        </Form.Item>
        {this.renderFooter()}
      </Form>
    );
  }
}

AddClientForm.propTypes = {
  intl: PropTypes.object,
  form: PropTypes.object,
  formCancel: PropTypes.func,
  onSubmitForm: PropTypes.func,
  createNewClientLoading: PropTypes.bool,
};

export default AddClientForm;
